import React from 'react'
import { connect } from 'react-redux'
import Activities from '../components/activities'

const mapStateToProps = (state) => ({
  ...state.activities
})

const mapDispatchToProps = dispatch => ({
  onDateChange: payload => dispatch({type: 'ACTIVITIES.CHANGE_DATE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Activities)
